import { render, staticRenderFns } from "./register-modal.vue?vue&type=template&id=c68bcbdc"
import script from "./register-modal.vue?vue&type=script&lang=js"
export * from "./register-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports